<template>
    <div>
        <org-models :showBtns="showBtns">

        </org-models>
    </div>
</template>

<script>
    import OrgModels from '@/components/organizationalModel/List';

    export default {
        components: {
            OrgModels
        },
        props: {
            showBtns: {
                default: true,
                type: Boolean
            },
        }
    }
</script>

<style scoped>
</style>
